import { useCallback } from 'react';

import { useDeviceType } from '@cian/ui-kit';

import { Socials } from 'shared/components/Socials';
import { useGuideAnalytics } from 'shared/hooks';
import { mapSocialItems } from 'shared/utils/socials';

import type { TSocialIcon, TSocials } from 'shared/types/socials';

interface ISocialsContainerProps {
  socials: TSocials;
}

export const SocialsContainer: React.FC<ISocialsContainerProps> = ({ socials }) => {
  const renderedItems = mapSocialItems(socials.items);
  const device = useDeviceType();
  const { trackSocialClick } = useGuideAnalytics();

  const handleItemClick = useCallback(
    (icon: TSocialIcon): void => {
      trackSocialClick(icon);
    },
    [trackSocialClick],
  );

  if (!socials.title.trim() || !renderedItems.length) {
    return null;
  }

  return <Socials device={device} title={socials.title} items={renderedItems} onItemClick={handleItemClick} />;
};
